import {Injectable} from '@angular/core';

interface Resource {
  name: string;
  src: string;
  type: string;
}

export const ResourcesStore: Resource[] = [

  {name: 'css/datatables/dataTables', src: 'assets/vendor/datatables/css/dataTables.bootstrap4.css', type: 'css'},
  {name: 'css/datatables/fixedHeader', src: 'assets/vendor/datatables/css/fixedHeader.bootstrap4.css', type: 'css'},
  {name: 'css/datatables/select', src: 'assets/vendor/datatables/css/select.bootstrap4.css', type: 'css'},
  {name: 'css/datatables/buttons', src: 'assets/vendor/datatables/css/buttons.bootstrap4.css', type: 'css'},

  {name: 'js/datatables/jquery.dataTables', src: 'https://cdn.datatables.net/1.10.19/js/jquery.dataTables.min.js', type: 'javascript'},
  {name: 'js/datatables/dataTables', src: 'assets/vendor/datatables/js/dataTables.bootstrap4.min.js', type: 'javascript'},
  {name: 'js/datatables/buttons', src: 'assets/vendor/datatables/js/buttons.bootstrap4.min.js', type: 'javascript'},
  {name: 'js/datatables/data-table.js', src: 'assets/vendor/datatables/js/data-table.js', type: 'javascript'},
  {
    name: 'js/datatables/fixedHeader',
    src: 'https://cdn.datatables.net/fixedheader/3.1.5/js/dataTables.fixedHeader.min.js',
    type: 'javascript'
  },

  /*{name: 'js/datatables/buttons', src: 'assets/vendor/datatables/css/buttons.bootstrap4.css', type: 'css'},
  {name: 'js/datatables/buttons', src: 'assets/vendor/datatables/css/buttons.bootstrap4.css', type: 'css'},
*/
];

declare var document: any;

@Injectable()
export class ResourcesLoaderService {

  private resources: any = {};

  constructor() {
    ResourcesStore.forEach((script: any) => {
      this.resources[script.name] = {
        loaded: false,
        src: script.src,
        type: script.type
      };
    });
  }

  public load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.resources[name].loaded) {
        if (this.resources[name].type === 'javascript') {
          // load script
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = this.resources[name].src;
          if (script.readyState) {  // IE
            script.onreadystatechange = () => {
              if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                this.resources[name].loaded = true;
                resolve({script: name, loaded: true, status: 'Loaded'});
              }
            };
          } else {  // Others
            script.onload = () => {
              this.resources[name].loaded = true;
              resolve({script: name, loaded: true, status: 'Loaded'});
            };
          }
          script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
          document.getElementsByTagName('head')[0].appendChild(script);
        } else {
          const style: HTMLLinkElement = document.createElement('link');
          style.href = this.resources[name].src;
          style.rel = 'stylesheet';
          document.getElementsByTagName('head')[0].appendChild(style);
          style.onload = () => {
            this.resources[name].loaded = true;
            resolve({script: name, loaded: true, status: 'Loaded'});
          };
        }
      } else {
        resolve({script: name, loaded: true, status: 'Already Loaded'});
      }
    });
  }

}
